<!-- <form [formGroup]="requirementCommentForm">
<div *ngIf="submissionType === 'precast'">
  <p class="heading">Thermal Requirements</p>
  <div class="row">
    <div class="col-md 12" *ngIf="selectedSampleTypes && selectedSampleTypes.indexOf('CONCRETE') >= 0">
      <mat-card-subtitle class="subtitle-instructions"> Concrete </mat-card-subtitle>
      <textarea
        matInput
        class="instructions-card"
        formControlName="concreteInstruction"
      placeholder="Please enter thermal requirement details about the selected samples here. Example: No higher than 50 C-cm/W at critical moisture content and 100 C-cm/W at zero (0%) moisture content"></textarea>
    </div>

    <div *ngIf="selectedSampleTypes && selectedSampleTypes.indexOf('FTB') >= 0">
      <mat-card-subtitle class="subtitle-instructions"> FTB  </mat-card-subtitle>
      <textarea
        matInput
        class="instructions-card"
        placeholder="Please enter thermal requirement details about the selected samples here. Example: No higher than 50 C-cm/W at critical moisture content and 100 C-cm/W at zero (0%) moisture content"
      formControlName="ftbInstruction"></textarea>
    </div>

    <div *ngIf="selectedSampleTypes && selectedSampleTypes.indexOf('GROUT/SLURRY') >= 0">
      <mat-card-subtitle class="subtitle-instructions"> Grout/Slurry  </mat-card-subtitle>
      <textarea
        matInput
        class="instructions-card"
        placeholder="Please enter thermal requirement details about the selected samples here. Example: No higher than 50 C-cm/W at critical moisture content and 100 C-cm/W at zero (0%) moisture content"
      formControlName="groutSlurryInstruction"></textarea>
    </div>

    <div *ngIf="selectedSampleTypes && selectedSampleTypes.indexOf('OTHER') >= 0">
      <mat-card-subtitle class="subtitle-instructions"> Others </mat-card-subtitle>
      <textarea
        matInput
        class="instructions-card"
        placeholder="Please enter thermal requirement details about the selected samples here. Example: No higher than 50 C-cm/W at critical moisture content and 100 C-cm/W at zero (0%) moisture content"
      formControlName="otherInstruction"></textarea>
    </div>
  </div>
</div>
<div *ngIf="submissionType === 'native-soil'">
  <p class="heading">Additional Comments</p>
  <div class="row">
    <div class="col-md 12">
      <mat-card-subtitle class="subtitle-instructions"> Comments </mat-card-subtitle>
      <textarea
        matInput
        class="instructions-card"
        placeholder="Please supply any additional comments on thermal requirements here"
      formControlName="additionalCommentsNativeSoil"></textarea>
    </div>
  </div>
</div>
</form> -->





@if (data && data.length > 0) {
  <form [formGroup]="requirementCommentForm">
    @if (submissionType === 'precast') {
      <div>
        <p class="heading">Thermal Requirements</p>
        <div class="row">
          <div class="col-md 12">
            @for (item of comments.controls; track item; let i = $index) {
              <div formArrayName="comments">
                <div [formGroupName]="i" class="form-group">
                  <mat-card-subtitle class="subtitle-instructions">
                    <strong>{{ getSampleTypeName(item.value.sampleTypeMasterId) }}</strong>
                  </mat-card-subtitle>
                  <p class="thermal-requirement-line">
                    No higher than
                    <input type="text" class="inline-input" formControlName="specifiedTR" /> at <input type="text" class="inline-input" formControlName="specifiedMoisture" /> moisture content and at
                    <input type="text" class="inline-input" formControlName="dryTR" /> in totally dry conditions (0%).
                  </p>
                  <textarea
                    matInput
                    maxlength="500"
                    class="instructions-card"
                    formControlName = "projectComment"
                  placeholder="Please enter thermal requirement details about the selected samples here. Example: No higher than 50 C-cm/W at critical moisture content and 100 C-cm/W at zero (0%) moisture content"></textarea>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (submissionType === 'native-soil') {
      <div>
        <p class="heading">Additional Comments</p>
        <div class="row">
          <div class="col-md 12">
            @for (item of comments.controls; track item; let i = $index) {
              <div formArrayName="comments">
                <div [formGroupName]="i" class="form-group">
                  <mat-card-subtitle class="subtitle-instructions"> Comments </mat-card-subtitle>
                  <textarea
                    matInput
                    class="instructions-card"
                    placeholder="Please supply any additional comments on thermal requirements here"
                    formControlName="projectComment"
                  maxlength="500"></textarea>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </form>
}



